import React from 'react'

const Heroes = () => {
  return (
    <div className='heroesFooter'>
        <img src="/heroesNew.svg" alt="Fast Heroes" />
    </div>
  );
};

export default Heroes